<template>
  <div>
    <el-button :loading="handleSaveLoading" style="float: right;margin-right: 5px;" @click="handleSave()" icon='el-icon-edit' size='mini' type="primary">保存</el-button>
    <span style="color: red;font-size: 12px;float:right;line-height: 30px;margin-right: 20px;">* 点击表格进行编辑</span>
    <h3>工厂及地址信息</h3>
    <el-table-edit :model="dataList" :columns="['categoryDesc','fullName','shortName','address','workshopNum']" ref="editTable">
      <el-table :data="dataList" size="small" stripe style="width: 100%;" @selection-change="selectionChangeHandle" ref="table" :row-class-name="rowClassName" @row-dblclick="editAll">
        <el-table-column type="selection" fixed="left"></el-table-column>
        <el-table-column label="序号" header-align="center" align="center" width="50" prop="index">
          <template slot-scope="scope">
            {{ scope.$index + 1 }}
          </template>
        </el-table-column>
        <el-table-column prop="categoryDesc" label="类型描述" align="center" header-align="center">
          <template slot-scope="scope">
            <span v-if="scope.row.categoryDesc === '配套产品生产'" style="color: red;">*</span>
            <span>{{scope.row.categoryDesc}}</span>
          </template>
        </el-table-column>
        <el-table-column prop="fullName" label="工厂名称" align="center" header-align="center">
          <template slot-scope="scope">
            <el-input v-if="scope.row.show" v-model="scope.row.fullName" placeholder="工厂名称"></el-input>
            <span v-else>{{scope.row.fullName}}</span>
          </template>
        </el-table-column>
        <el-table-column prop="shortName" label="工厂简称" align="center" header-align="center">
          <template slot-scope="scope">
            <el-input v-if="scope.row.show" v-model="scope.row.shortName" placeholder="工厂简称"></el-input>
            <span v-else>{{scope.row.shortName}}</span>
          </template>
        </el-table-column>
        <el-table-column prop="address" label="地址" header-align="center" align="center">
          <template slot-scope="scope">
            <el-input type="email" v-if="scope.row.show" v-model="scope.row.address" placeholder="地址"></el-input>
            <span v-else>{{scope.row.address}}</span>
          </template>
        </el-table-column>
      </el-table>
    </el-table-edit>
    <el-pagination
            @size-change="sizeChangeHandle"
            @current-change="currentChangeHandle"
            :current-page="pageIndex"
            :page-sizes="[10,15,20]"
            :page-size="pageSize"
            :total="totalPage"
            layout="total, sizes, prev, pager, next, jumper">
    </el-pagination>
  </div>
</template>

<script>
  import Vue from 'vue'
  import { saveSupplierFactories, listSupplierFactories, listInvitedForSupplier } from '@/controller/portal'
  export default {
    computed: {
      editTable() {
        return this.$refs.editTable
      }
    },
    data () {
      return {
        handleSaveLoading:false,
        show:false,
        totalPage: 0,
        pageIndex:1,
        pageSize:15,
        dataForm: {
          key: ''
        },
        dataListLoading: false,
        editRowslist: [],
        dataList: [
          { categoryDesc: '配套产品研发', value: '1' },
          { categoryDesc: '配套产品生产', value: '2' },
          { categoryDesc: '配套产品销售', value: '3' },
          { categoryDesc: '配套产品委托加工', value: '4' }
        ],
        categoryDesc: '',
        fullName: '',
        shortName: '',
        address: '',
        venderInviteFid: '',
        // applyStatus: '',
        dataListSelections: []
      }
    },
    props: {
      superId: Number
    },
    mounted() {
      this.getList()
    },
    watch: {
      venderInviteFid() {
        this.getDataList()
      }
    },
    methods: {
      // 每页数
      sizeChangeHandle (val) {
        this.pageSize = val
        this.pageIndex = 1
        this.getDataList()
      },
      // 当前页
      currentChangeHandle (val) {
        this.pageIndex = val
        this.getDataList()
      },
      handleNewRows() {
        this.dataList.push({
          // edit: true,
        })
      },
      deletefront(row) {
        this.dataList.splice(row,1);
      },
      editAll() {
        //debugger
        let data = JSON.parse(JSON.stringify(this.dataList ? this.dataList : []));
        data.forEach((element) => {
          element["show"] = true;
        });
        this.dataList = data;
      },
      handleSave() {
        //校验必填
        for(var i=0; i<this.dataList.length;i++){
          if ("配套产品生产" === this.dataList[i].categoryDesc) {
            if(!this.dataList[i].fullName){
              this.$message.error("配套产品生产的工厂名称，不可为空")
              return
            }
            if(!this.dataList[i].shortName){
              this.$message.error("配套产品生产的工厂简称，不可为空")
              return
            }
            if(!this.dataList[i].address){
              this.$message.error("配套产品生产的地址，不可为空")
              return
            }
          }
        }
        //调用保存方法
        this.saveData(this.dataList)
      },
      saveData(list) {
        this.handleSaveLoading = true
        saveSupplierFactories({
          'factoryList' : list,
          'inviteId': this.superId
        }).then(data => {
          if (data && data.code === '00') {
            this.$message({
              message: '操作成功',
              type: 'success',
            })
            this.getDataList()
            this.handleSaveLoading = false
          } else {
            this.handleSaveLoading = false
            this.$message.error(data.msg)
          }
        }).catch((e) => {
          this.handleSaveLoading = false
        })
      },
      getDataList() {
        listSupplierFactories({
          'pageNo': this.pageIndex,
          'pageSize': this.pageSize,
          'inviteId' : this.superId
        }).then(data => {
          if (data && data.code === '00') {
            if (data.body.records.length > 0){
              this.dataList = data.body.records
              this.totalPage = data.body.total
            }
          } else {
            this.totalPage = 0
          }
          this.dataListLoading = false
        })
      },
      // 多选
      selectionChangeHandle(val) {
        this.dataListSelections = val
      },
      rowClassName({
                     row,
                     rowIndex
                   }) {
        row.rowid = rowIndex + 1;
      },
      getList() {
        listInvitedForSupplier().then(data => {
          this.venderInviteFid = data.body.records[0].id
        })
      },
    }
  }
</script>
